import { Theme } from '@mui/material/styles'
import type { ThemeMode } from './ThemeContext'
import { darkTheme } from './darkTheme/darkTheme'
import { grayscaleTheme } from './grayscaleTheme/grayscaleTheme'
import { lightTheme } from './lightTheme/lightTheme'
import { obxopsTheme } from './obxopsTheme/obxopsTheme'

/**
 * Creates the application theme based on the selected mode
 * This preserves all the original theme configurations from darkTheme.js and lightTheme.js
 *
 * To customize colors, typography, spacing, or component styles:
 * - Edit this file directly
 * - All theme customizations are centralized here
 */
export const createAppTheme = (mode: ThemeMode): Theme => {
  switch (mode) {
    case 'dark':
      return darkTheme
    case 'light':
      return lightTheme
    case 'obxops':
      return obxopsTheme
    case 'grayscale':
    default:
      return grayscaleTheme
  }
}
